function isMobile() {
    return window.innerWidth < 768
}
function isTablet() {
    return window.innerWidth < 1025 && window.innerWidth > 767
}
function isDesktop() {
    return window.innerWidth > 1024
}
function isSafariMobile(){
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && isMobile();
}

function isSafari(){
    return navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
}

export {
    isMobile,
    isTablet,
    isDesktop,
    isSafariMobile,
    isSafari,
}